const environments = {
  local: {
    url: "http://0.0.0.0:8003/",
    // url: "http://0.0.0.0:9033/",
    // url: "https://sdeiaiml.com:9034/",
    
  },

  staging: {
    url: "https://sdeiaiml.com:9034/",
  },
  
  production: {
     url: "https://itafclinicalapp.com/api/",
  },
};
export default environments;
